/**
 * StatoBonificoBadge — Badge colorato per stato bonifico.
 * Mappa ogni stato a una classe Tailwind coerente con il design system.
 */

import React from 'react';

interface Props {
  /** Stato del bonifico (bozza, in_attesa_sca, inviato, eseguito, rifiutato, annullato). */
  stato: string;
}

const STATO_MAP: Record<string, { className: string; label: string }> = {
  bozza: { className: 'bg-muted text-muted-foreground', label: 'Bozza' },
  in_attesa_sca: { className: 'bg-accent/10 text-accent', label: 'In attesa SCA' },
  inviato: { className: 'bg-primary/10 text-primary', label: 'Inviato' },
  eseguito: {
    className: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
    label: 'Eseguito',
  },
  rifiutato: { className: 'bg-destructive/10 text-destructive', label: 'Rifiutato' },
  annullato: { className: 'bg-muted text-muted-foreground', label: 'Annullato' },
};

/**
 * Visualizza lo stato di un bonifico come badge colorato inline.
 *
 * @param stato - Stato del bonifico dalla API
 */
export const StatoBonificoBadge: React.FC<Props> = ({ stato }) => {
  const config = STATO_MAP[stato] ?? { className: 'bg-muted text-muted-foreground', label: stato };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default StatoBonificoBadge;
